(function(){
  function qsa(r,s){ return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function clamp(n,a,b){ return Math.max(a, Math.min(b, n)); }
  function getVarPx(el, name, fallback){
    var raw = getComputedStyle(el).getPropertyValue(name);
    var n = parseFloat(raw);
    return isNaN(n) ? (fallback || 0) : n;
  }
  function getSlideH(scroller){ return getVarPx(scroller, '--slide-h', 460); }
  function getHeaderOffset(scroller){ return getVarPx(scroller, '--header-offset', 0); }

  function initAll(){
    qsa(document,'[data-parallax-slideshow]').forEach(initOne);
  }

  function initOne(scroller){
    if (!scroller || scroller.__snapInit) return;
    scroller.__snapInit = true;

    var root    = scroller.closest('.parallax-slideshow') || scroller.parentNode || document;
    var slides  = qsa(scroller, '.parallax-slide');
    var dots    = qsa(root, '.parallax-slideshow__dot');
    var prevBtn = root.querySelector('[data-nav="prev"]');
    var nextBtn = root.querySelector('[data-nav="next"]');

    // Soft release distances (in px), tunable via CSS vars on .parallax-slideshow
    // You can set:
    //   --scroll-release-top
    //   --scroll-release-bottom
    // per breakpoint in CSS..
    var TOP_RELEASE_PX = (function(){
      var fromCSS = getVarPx(root, '--scroll-release-top', NaN);
      if (!isNaN(fromCSS)) return fromCSS;
      var padTop = getVarPx(root, '--slide-pad-top', 0);
      var hdr    = getHeaderOffset(scroller);
      // Use the larger of pad/header (or 60) but cap it to avoid too-early exits
      return Math.min(Math.max(padTop, hdr, 60), 160);
    })();

    var BOTTOM_RELEASE_PX = (function(){
      var fromCSS = getVarPx(root, '--scroll-release-bottom', NaN);
      if (!isNaN(fromCSS)) return fromCSS;
      var h = getSlideH(scroller);
      // ~12% of a slide height feels natural; clamp to a reasonable band
      return Math.min(Math.max(h * 0.12, 80), 180);
    })();

    function atTop(){ return scroller.scrollTop <= 2; }
    function atBottom(){ return scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop <= 2; }
    function atTopSoft(){ return scroller.scrollTop <= TOP_RELEASE_PX; }
    function atBottomSoft(){
      var remaining = scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop;
      return remaining <= BOTTOM_RELEASE_PX;
    }

    // Temporarily disable CSS snap to avoid flick when scroll chains to page
    function tempDisableSnap(){
      var prev = scroller.style.scrollSnapType;
      scroller.style.scrollSnapType = 'none';
      setTimeout(function(){ scroller.style.scrollSnapType = prev; }, 180);
    }

    function currentIndex(){
      var st = Math.max(0, scroller.scrollTop - getHeaderOffset(scroller));
      var h  = getSlideH(scroller);
      return clamp(Math.round(st / h), 0, slides.length - 1);
    }

    function scrollToIndex(i){
      i = clamp(i, 0, slides.length - 1);
      slides[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function updateDots(idx){
      dots.forEach(function(d,i){ d.setAttribute('aria-current', i===idx ? 'true' : 'false'); });
    }

    function updateButtons(idx){
      if (prevBtn) prevBtn.disabled = (idx === 0);
      if (nextBtn) nextBtn.disabled = (idx === slides.length - 1);
    }

    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          entry.target.classList.add('seen');
        }
      });
    }, { root: scroller, threshold: [0,0.6,1] }) : null;
    if (io) slides.forEach(function(s){ io.observe(s); });

    var rafId = null;
    scroller.addEventListener('scroll', function(){
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function(){
        var idx = currentIndex();
        updateDots(idx);
        updateButtons(idx);
      });
    }, { passive: true });

    dots.forEach(function(d){
      d.addEventListener('click', function(){
        var i = parseInt(d.getAttribute('data-dot'), 10) || 0;
        scrollToIndex(i);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function(){ scrollToIndex(currentIndex()-1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ scrollToIndex(currentIndex()+1); });

    function enableHandoff(){ scroller.style.overscrollBehaviorY = 'auto'; }
    function disableHandoff(){ scroller.style.overscrollBehaviorY = 'contain'; }

    function innerScrollableCanScroll(target, dir){
      var el = target;
      while (el && el !== scroller){
        var cs = getComputedStyle(el);
        var canScroll = /(auto|scroll|overlay)/.test(cs.overflowY);
        if (canScroll && el.scrollHeight > el.clientHeight){
          if (dir > 0 && el.scrollTop + el.clientHeight + 1 < el.scrollHeight) return true; // down
          if (dir < 0 && el.scrollTop > 0) return true;                                      // up
        }
        el = el.parentElement;
      }
      return false;
    }

    scroller.addEventListener('wheel', function(e){
      var dy = e.deltaY;
      var dir = dy > 0 ? 1 : (dy < 0 ? -1 : 0);
      if (!dir) return;

      if (innerScrollableCanScroll(e.target, dir)) { disableHandoff(); return; }
      // Soft release at both edges
      if (dir > 0 && atBottomSoft()){ tempDisableSnap(); enableHandoff(); return; }
      if (dir < 0 && atTopSoft()){   tempDisableSnap(); enableHandoff(); return; }

      disableHandoff();
    }, { passive: true });

    var touchStartY = null;
    scroller.addEventListener('touchstart', function(e){
      var t = e.touches && e.touches[0]; touchStartY = t ? t.clientY : null;
    }, { passive: true });

    scroller.addEventListener('touchmove', function(e){
      if (touchStartY == null) return;
      var t = e.touches && e.touches[0]; if (!t) return;
      var dy = t.clientY - touchStartY;  // + up / - down (finger)
      var dir = dy < 0 ? 1 : (dy > 0 ? -1 : 0);
      if (!dir) return;
      if (innerScrollableCanScroll(e.target, dir)) { disableHandoff(); return; }
      if (dir > 0 && atBottomSoft()){ tempDisableSnap(); enableHandoff(); return; }
      if (dir < 0 && atTopSoft()){
        if (Math.abs(dy) >= 24){ tempDisableSnap(); enableHandoff(); return; }
        disableHandoff(); return;
      }

      disableHandoff();
    }, { passive: true });

    scroller.addEventListener('touchend', function(){ touchStartY = null; }, { passive: true });
    scroller.addEventListener('keydown', function(e){
      var key = e.key;
      var downKey = (key === 'ArrowDown' || key === 'PageDown' || key === ' ');
      var upKey   = (key === 'ArrowUp'   || key === 'PageUp');
      if (downKey && atBottomSoft()){ tempDisableSnap(); enableHandoff(); return; }
      if (upKey   && atTopSoft()){    tempDisableSnap(); enableHandoff(); return; }
      disableHandoff();
    });

    var startIdx = currentIndex();
    updateDots(startIdx);
    updateButtons(startIdx);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
